enum ActionTypes {
    INIT = "extensions/init",
    LOAD_EXTENSIONS = "extensions/loadExtensions",
    LOAD = "extensions/load",
    RELOAD = "extensions/reload",
    LOADED = "extensions/loaded",
    FAILED_TO_LOAD = "extensions/failedToLoad",
    OPEN_SETTINGS = "extensions/openSettings",
    CLOSE_SETTINGS = "extensions/closeSettings",
    ADD = "extensions/add",
    ENABLE = "extensions/enable",
    UPDATE_OPTION = "extensions/updateOption",
    DISABLE = "extensions/disable",
    REMOVE = "extensions/remove",
    ADD_EXTENSION_REQUEST = "extensions/addExtensionRequest",
    ADD_EXTENSION_SUCCESS = "extensions/addExtensionSuccess",
    ADD_EXTENSION_FAILED = "extensions/addExtensionFailed"
}

export default ActionTypes;
